import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import qs from 'qs';
import { replace } from 'react-router-redux';
import Moment from 'moment';
import { updateScheduleFilters, navigate } from 'actionCreators';
import { getScheduleDates } from '../../../../reducers';
import Calendar from 'calendar';
import { CalendarFilterType } from 'types/filter';

class Schedule extends React.Component {
  state = { date: new Date() };

  componentWillMount = () => {
    const { location, user } = this.props;
    if (!['Estimator', 'Installer'].includes(user.employable_type) && location.search) {
      this.props.replace(`${this.props.location.pathname}`);
    }
    if (['Estimator', 'Installer'].includes(user.employable_type)) {
      const filters = user.employable_type === 'Installer' ? { assignee_type: ['Crew'] } :
        { assignee_type: ['Estimator'] };
      this.props.updateScheduleFilters(filters);
      this.updateFilters(filters, true);
    }
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.location.search && newProps.location.search !== this.props.location.search) {
      this.applyFilterObjToScheduleFilters(newProps.location.search);
    }
  }

  applyFilterObjToScheduleFilters = (search) => {
    const filterObject = qs.parse(search.slice(1), { arrayLimit: 1000 });
    if (filterObject.workroom) {
      filterObject.workroom = filterObject.workroom.map(id => parseInt(id, 10));
    }
    if (filterObject.surface_type) {
      filterObject.surface_type = filterObject.surface_type.map(id => parseInt(id, 10));
    }
    this.props.updateScheduleFilters(filterObject);
  }

  handleFilterChange = (key, values) => this.updateFilters({
    ...this.props.filters, [key]: values,
  });

  updateFilters = (newFilters, isRestricted = false) => {
    const filters = qs.stringify(newFilters);
    if (!filters && !isRestricted) this.props.updateScheduleFilters({});
    this.props.replace(`${this.props.location.pathname}${filters ? `?${filters}` : ''}`);
  }

  render = () => {
    const { dates, filters, user: { name, role, employable_id } } = this.props;
    const date = this.props.day ?
      new Date(this.props.year, this.props.month - 1, this.props.day) :
      this.state.date;
    return (<Calendar
      title="Schedule"
      date={date}
      dates={dates}
      filters={filters}
      role={role}
      employableId={employable_id}
      username={name}
      onFilterChange={this.handleFilterChange}
      updateScheduleFilters={this.props.updateScheduleFilters}
      updateFilters={this.updateFilters}
      isScheduleBoard
    />);
  }
}

Schedule.propTypes = {
  dates: PropTypes.arrayOf(PropTypes.instanceOf(Moment)).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  filters: CalendarFilterType,
  year: PropTypes.number,
  month: PropTypes.number,
  day: PropTypes.number,
  updateScheduleFilters: PropTypes.func,
  navigate: PropTypes.func,
  user: PropTypes.object,
  replace: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  filters: state.schedule.filters,
  dates: getScheduleDates(state),
  year: ownProps.params.year ? parseInt(ownProps.params.year, 10) : undefined,
  month: ownProps.params.month ? parseInt(ownProps.params.month, 10) : undefined,
  day: ownProps.params.day ? parseInt(ownProps.params.day, 10) : undefined,
});

export default connect(mapStateToProps, {
  updateScheduleFilters, navigate, replace,
})(Schedule);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/index.jsx